export const config = {
  enableScrollSmoother: true, // ScrollSmootherを有効にするかどうか
  enableBarba: false,          // BarbaJSを有効にするかどうか
  recaptchaPublicKey: '', // TODO reCAPTCHAの公開鍵（PHP側に秘密鍵もあるので変更等注意）
};